module.exports = __webpack_public_path__ + "img/icon-meeting.9fbefb20.png";